import { Component,  OnInit,  ElementRef, ViewChild,  AfterViewInit } from "@angular/core"
import {  FormBuilder,  FormGroup, Validators } from "@angular/forms"
import  { Router } from "@angular/router"
import  { HttpService } from "src/app/shared/services/http.service"

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit, AfterViewInit {
  public show = false
  public registerForm: FormGroup
  public loginForm: FormGroup
  showPassword = false
  public submitted = false
  public formErrors: string[] = []
  public activeTab: "login" | "register" = "login"

  @ViewChild("container") container!: ElementRef

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpService,
  ) {
    // Update the phone validation to include maxLength
    this.registerForm = this.fb.group({
      name: ["", [Validators.required]],
      user_name: ["", [Validators.required, Validators.minLength(3)]],
      company_name: ["", [Validators.required]],
      country: ["", [Validators.required]],
      referredBy: [""], // Optional field
      currency: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      contact_no: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(14)]], // Added maxLength
      password: ["", [Validators.required, Validators.minLength(6)]],
      type: ["user", [Validators.required]],
    })

    // Initialize login form
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
      type: ["user", [Validators.required]],
    })
  }

  ngOnInit() {
    // Reset submission state when form changes
    this.registerForm.valueChanges.subscribe(() => {
      if (this.submitted) {
        this.formErrors = []
      }
    })
  }

  ngAfterViewInit() {
    const signUpButton = document.getElementById("signUp")
    const signInButton = document.getElementById("signIn")
    const loginTab = document.getElementById("loginTab")
    const registerTab = document.getElementById("registerTab")

    if (signUpButton && signInButton) {
      signUpButton.addEventListener("click", () => {
        this.container.nativeElement.classList.add("right-panel-active")
        this.activeTab = "register"
      })

      signInButton.addEventListener("click", () => {
        this.container.nativeElement.classList.remove("right-panel-active")
        this.activeTab = "login"
      })
    }

    if (loginTab && registerTab) {
      loginTab.addEventListener("click", () => {
        this.activeTab = "login"
      })

      registerTab.addEventListener("click", () => {
        this.activeTab = "register"
      })
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword
  }

  onSubmit() {
    this.submitted = true
    this.registerForm.markAllAsTouched()
    this.formErrors = []

    if (this.registerForm.valid) {
      // No need to process phone number - it's already a simple string
      this.singUp()
    } else {
      // Scroll to the first error
      setTimeout(() => {
        const firstInvalidElement = document.querySelector(".validation-feedback .error-message")
        if (firstInvalidElement) {
          firstInvalidElement.scrollIntoView({ behavior: "smooth", block: "center" })
        }
      }, 100)
    }
  }

  singUp() {
    // Clean the phone number before sending (remove any extra spaces/formatting)
    const formData = { ...this.registerForm.value }
    if (formData.contact_no) {
      // Clean the phone number but keep it as a string
      formData.contact_no = formData.contact_no.trim()
    }

    this.http.post("signup", formData, true).subscribe(
      (res: any) => {
        console.log("Registration successful", res)
        this.submitted = false // Reset submission state
        this.registerForm.reset() // Clear the form
        this.switchToLogin() // Switch to login after successful registration
      },
      (err: any) => {
        console.log(err)
        this.submitted = false // Reset submission state on error
      },
    )
  }

  switchToLogin() {
    this.container.nativeElement.classList.remove("right-panel-active")
    this.activeTab = "login"
  }

  login() {
    if (this.loginForm.valid) {
      this.http.post("login", this.loginForm.value, false).subscribe(
        (res: any) => {
          console.log(res, "helloresss")

          localStorage.setItem("token", JSON.stringify(res?.token))
          localStorage.setItem("user", JSON.stringify(res?.user))

          this.router.navigate(["/dashboard/default"])
        },
        (err: any) => {
          console.error("Login failed", err)
        },
      )
    } else {
      console.log("Login form is invalid")
    }
  }
}
